import {isMountedInShell} from '../shellRemote';

/**
 * Positioning for the app-level loading overlays (`WorkspaceLoader`,
 * `InstrumentedFloatingWaveLoader`).
 *
 * Standalone, the overlay pins to the viewport and stacks per
 * `standaloneClassName`, which may sit above the W&B nav. In the Forge shell
 * the header and the ARIA drawer are shell-owned chrome that should stay
 * visible and interactive while a page loads, so the overlay instead fills the
 * shell's remote container (which is `position: relative`) and stays below the
 * drawer, which renders at `z-[100]` (see `WBAgentChatDrawer`).
 */
export function appLoaderOverlayClassName(standaloneClassName: string): string {
  return isMountedInShell()
    ? 'absolute inset-0 z-[50]'
    : `fixed inset-0 ${standaloneClassName}`;
}
